module.exports = __webpack_public_path__ + "static/img/ad13.c8704fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/ad13.png
// module id = h1QF
// module chunks = 13